export default __webpack_public_path__ + "static/media/bg-login28.f0fabe06.webp";